import { css } from 'styled-components';

export const materialGridStyles = css`
  .mb-0 {
    margin-bottom: 0 !important;
  }

  .mb-1 {
    margin-bottom: 5px !important;
  }

  .mt-0 {
    margin-top: 0 !important;
  }

  .mt-1 {
    margin-top: 5px !important;
  }

  .mt-2 {
    margin-top: 18px !important;
  }

  .m-0 {
    margin: 0 !important;
  }

  .w-50 {
    width: 50%;
  }

  .w-75 {
    width: 75%;
  }

  .h-50 {
    height: calc(50% - 12px) !important;
  }

  .MuiGrid2-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
  }

  .MuiGrid2-item {
    margin: 0;
    box-sizing: border-box;
  }

  .MuiGrid2-zeroMinWidth {
    min-width: 0;
  }

  .MuiGrid2-direction-xs-column {
    flex-direction: column;
  }

  .MuiGrid2-direction-xs-column-reverse {
    flex-direction: column-reverse;
  }

  .MuiGrid2-direction-xs-row-reverse {
    flex-direction: row-reverse;
  }

  .MuiGrid2-wrap-xs-nowrap {
    flex-wrap: nowrap;
  }

  .MuiGrid2-wrap-xs-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .MuiGrid2-align-items-xs-center {
    align-items: center;
  }

  .MuiGrid2-align-items-xs-flex-start {
    align-items: flex-start;
  }

  .MuiGrid2-align-items-xs-flex-end {
    align-items: flex-end;
  }

  .MuiGrid2-align-items-xs-baseline {
    align-items: baseline;
  }

  .MuiGrid2-align-content-xs-center {
    align-content: center;
  }

  .MuiGrid2-align-content-xs-flex-start {
    align-content: flex-start;
  }

  .MuiGrid2-align-content-xs-flex-end {
    align-content: flex-end;
  }

  .MuiGrid2-align-content-xs-space-between {
    align-content: space-between;
  }

  .MuiGrid2-align-content-xs-space-around {
    align-content: space-around;
  }

  .MuiGrid2-justify-xs-center {
    justify-content: center;
  }

  .MuiGrid2-justify-xs-flex-end {
    justify-content: flex-end;
  }

  .MuiGrid2-justify-xs-space-between {
    justify-content: space-between;
  }

  .MuiGrid2-justify-xs-space-around {
    justify-content: space-around;
  }

  .MuiGrid2-justify-xs-space-evenly {
    justify-content: space-evenly;
  }

  .MuiGrid2-spacing-xs-1 {
    width: calc(100% + 8px);
    margin: -4px;
  }

  .MuiGrid2-spacing-xs-1 > .MuiGrid2-item {
    padding: 4px;
  }

  .MuiGrid2-spacing-xs-2 {
    width: calc(100% + 16px);
    margin: -8px;
  }

  .MuiGrid2-spacing-xs-2 > .MuiGrid2-item {
    padding: 8px;
  }

  .MuiGrid2-spacing-xs-3 {
    width: calc(100% + 24px);
    margin: 0 -12px;
  }

  .MuiGrid2-spacing-xs-3 > .MuiGrid2-item {
    padding: 12px;
  }

  .MuiGrid2-spacing-xs-4 {
    width: calc(100% + 32px);
    margin: -16px;
  }

  .MuiGrid2-spacing-xs-4 > .MuiGrid2-item {
    padding: 16px;
  }

  .MuiGrid2-spacing-xs-5 {
    width: calc(100% + 40px);
    margin: -20px;
  }

  .MuiGrid2-spacing-xs-5 > .MuiGrid2-item {
    padding: 20px;
  }

  .MuiGrid2-spacing-xs-6 {
    width: calc(100% + 48px);
    margin: -24px;
  }

  .MuiGrid2-spacing-xs-6 > .MuiGrid2-item {
    padding: 24px;
  }

  .MuiGrid2-spacing-xs-7 {
    width: calc(100% + 56px);
    margin: -28px;
  }

  .MuiGrid2-spacing-xs-7 > .MuiGrid2-item {
    padding: 28px;
  }

  .MuiGrid2-spacing-xs-8 {
    width: calc(100% + 64px);
    margin: -32px;
  }

  .MuiGrid2-spacing-xs-8 > .MuiGrid2-item {
    padding: 32px;
  }

  .MuiGrid2-spacing-xs-9 {
    width: calc(100% + 72px);
    margin: -36px;
  }

  .MuiGrid2-spacing-xs-9 > .MuiGrid2-item {
    padding: 36px;
  }

  .MuiGrid2-spacing-xs-10 {
    width: calc(100% + 80px);
    margin: -40px;
  }

  .MuiGrid2-spacing-xs-10 > .MuiGrid2-item {
    padding: 40px;
  }

  .MuiGrid2-grid-xs-auto {
    flex-grow: 0;
    max-width: none;
    flex-basis: auto;
  }

  .MuiGrid2-grid-xs-true {
    flex-grow: 1;
    max-width: 100%;
    flex-basis: 0;
  }

  .MuiGrid2-grid-xs-1 {
    flex-grow: 0;
    max-width: 8.333333%;
    flex-basis: 8.333333%;
  }

  .MuiGrid2-grid-xs-2 {
    flex-grow: 0;
    max-width: 16.666667%;
    flex-basis: 16.666667%;
  }

  .MuiGrid2-grid-xs-3 {
    flex-grow: 0;
    max-width: 25%;
    flex-basis: 25%;
  }

  .MuiGrid2-grid-xs-4 {
    flex-grow: 0;
    max-width: 33.333333%;
    flex-basis: 33.333333%;
  }

  .MuiGrid2-grid-xs-5 {
    flex-grow: 0;
    max-width: 41.666667%;
    flex-basis: 41.666667%;
  }

  .MuiGrid2-grid-xs-6 {
    flex-grow: 0;
    max-width: 50%;
    flex-basis: 50%;
  }

  .MuiGrid2-grid-xs-7 {
    flex-grow: 0;
    max-width: 58.333333%;
    flex-basis: 58.333333%;
  }

  .MuiGrid2-grid-xs-8 {
    flex-grow: 0;
    max-width: 66.666667%;
    flex-basis: 66.666667%;
  }

  .MuiGrid2-grid-xs-9 {
    flex-grow: 0;
    max-width: 75%;
    flex-basis: 75%;
  }

  .MuiGrid2-grid-xs-10 {
    flex-grow: 0;
    max-width: 83.333333%;
    flex-basis: 83.333333%;
  }

  .MuiGrid2-grid-xs-11 {
    flex-grow: 0;
    max-width: 91.666667%;
    flex-basis: 91.666667%;
  }

  .MuiGrid2-grid-xs-12 {
    flex-grow: 0;
    max-width: 100%;
    flex-basis: 100%;
  }
  @media (min-width: 600px) {
    .MuiGrid2-grid-sm-auto {
      flex-grow: 0;
      max-width: none;
      flex-basis: auto;
    }

    .MuiGrid2-grid-sm-true {
      flex-grow: 1;
      max-width: 100%;
      flex-basis: 0;
    }

    .MuiGrid2-grid-sm-1 {
      flex-grow: 0;
      max-width: 8.333333%;
      flex-basis: 8.333333%;
    }

    .MuiGrid2-grid-sm-2 {
      flex-grow: 0;
      max-width: 16.666667%;
      flex-basis: 16.666667%;
    }

    .MuiGrid2-grid-sm-3 {
      flex-grow: 0;
      max-width: 25%;
      flex-basis: 25%;
    }

    .MuiGrid2-grid-sm-4 {
      flex-grow: 0;
      max-width: 33.333333%;
      flex-basis: 33.333333%;
    }

    .MuiGrid2-grid-sm-5 {
      flex-grow: 0;
      max-width: 41.666667%;
      flex-basis: 41.666667%;
    }

    .MuiGrid2-grid-sm-6 {
      flex-grow: 0;
      max-width: 50%;
      flex-basis: 50%;
    }

    .MuiGrid2-grid-sm-7 {
      flex-grow: 0;
      max-width: 58.333333%;
      flex-basis: 58.333333%;
    }

    .MuiGrid2-grid-sm-8 {
      flex-grow: 0;
      max-width: 66.666667%;
      flex-basis: 66.666667%;
    }

    .MuiGrid2-grid-sm-9 {
      flex-grow: 0;
      max-width: 75%;
      flex-basis: 75%;
    }

    .MuiGrid2-grid-sm-10 {
      flex-grow: 0;
      max-width: 83.333333%;
      flex-basis: 83.333333%;
    }

    .MuiGrid2-grid-sm-11 {
      flex-grow: 0;
      max-width: 91.666667%;
      flex-basis: 91.666667%;
    }

    .MuiGrid2-grid-sm-12 {
      flex-grow: 0;
      max-width: 100%;
      flex-basis: 100%;
    }
  }
  @media (min-width: 900px) {
    .MuiGrid2-grid-md-auto {
      flex-grow: 0;
      max-width: none;
      flex-basis: auto;
    }

    .MuiGrid2-grid-md-true {
      flex-grow: 1;
      max-width: 100%;
      flex-basis: 0;
    }

    .MuiGrid2-grid-md-1 {
      flex-grow: 0;
      max-width: 8.333333%;
      flex-basis: 8.333333%;
    }

    .MuiGrid2-grid-md-2 {
      flex-grow: 0;
      max-width: 16.666667%;
      flex-basis: 16.666667%;
    }

    .MuiGrid2-grid-md-3 {
      flex-grow: 0;
      max-width: 25%;
      flex-basis: 25%;
    }

    .MuiGrid2-grid-md-4 {
      flex-grow: 0;
      max-width: 33.333333%;
      flex-basis: 33.333333%;
    }

    .MuiGrid2-grid-md-5 {
      flex-grow: 0;
      max-width: 41.666667%;
      flex-basis: 41.666667%;
    }

    .MuiGrid2-grid-md-6 {
      flex-grow: 0;
      max-width: 50%;
      flex-basis: 50%;
    }

    .MuiGrid2-grid-md-7 {
      flex-grow: 0;
      max-width: 58.333333%;
      flex-basis: 58.333333%;
    }

    .MuiGrid2-grid-md-8 {
      flex-grow: 0;
      max-width: 66.666667%;
      flex-basis: 66.666667%;
    }

    .MuiGrid2-grid-md-9 {
      flex-grow: 0;
      max-width: 75%;
      flex-basis: 75%;
    }

    .MuiGrid2-grid-md-10 {
      flex-grow: 0;
      max-width: 83.333333%;
      flex-basis: 83.333333%;
    }

    .MuiGrid2-grid-md-11 {
      flex-grow: 0;
      max-width: 91.666667%;
      flex-basis: 91.666667%;
    }

    .MuiGrid2-grid-md-12 {
      flex-grow: 0;
      max-width: 100%;
      flex-basis: 100%;
    }
  }
  @media (min-width: 1280px) {
    .MuiGrid2-grid-lg-auto {
      flex-grow: 0;
      max-width: none;
      flex-basis: auto;
    }

    .MuiGrid2-grid-lg-true {
      flex-grow: 1;
      max-width: 100%;
      flex-basis: 0;
    }

    .MuiGrid2-grid-lg-1 {
      flex-grow: 0;
      max-width: 8.333333%;
      flex-basis: 8.333333%;
    }

    .MuiGrid2-grid-lg-2 {
      flex-grow: 0;
      max-width: 16.666667%;
      flex-basis: 16.666667%;
    }

    .MuiGrid2-grid-lg-3 {
      flex-grow: 0;
      max-width: 25%;
      flex-basis: 25%;
    }

    .MuiGrid2-grid-lg-4 {
      flex-grow: 0;
      max-width: 33.333333%;
      flex-basis: 33.333333%;
    }

    .MuiGrid2-grid-lg-5 {
      flex-grow: 0;
      max-width: 41.666667%;
      flex-basis: 41.666667%;
    }

    .MuiGrid2-grid-lg-6 {
      flex-grow: 0;
      max-width: 50%;
      flex-basis: 50%;
    }

    .MuiGrid2-grid-lg-7 {
      flex-grow: 0;
      max-width: 58.333333%;
      flex-basis: 58.333333%;
    }

    .MuiGrid2-grid-lg-8 {
      flex-grow: 0;
      max-width: 66.666667%;
      flex-basis: 66.666667%;
    }

    .MuiGrid2-grid-lg-9 {
      flex-grow: 0;
      max-width: 75%;
      flex-basis: 75%;
    }

    .MuiGrid2-grid-lg-10 {
      flex-grow: 0;
      max-width: 83.333333%;
      flex-basis: 83.333333%;
    }

    .MuiGrid2-grid-lg-11 {
      flex-grow: 0;
      max-width: 91.666667%;
      flex-basis: 91.666667%;
    }

    .MuiGrid2-grid-lg-12 {
      flex-grow: 0;
      max-width: 100%;
      flex-basis: 100%;
    }
  }
  @media (min-width: 1920px) {
    .MuiGrid2-grid-xl-auto {
      flex-grow: 0;
      max-width: none;
      flex-basis: auto;
    }

    .MuiGrid2-grid-xl-true {
      flex-grow: 1;
      max-width: 100%;
      flex-basis: 0;
    }

    .MuiGrid2-grid-xl-1 {
      flex-grow: 0;
      max-width: 8.333333%;
      flex-basis: 8.333333%;
    }

    .MuiGrid2-grid-xl-2 {
      flex-grow: 0;
      max-width: 16.666667%;
      flex-basis: 16.666667%;
    }

    .MuiGrid2-grid-xl-3 {
      flex-grow: 0;
      max-width: 25%;
      flex-basis: 25%;
    }

    .MuiGrid2-grid-xl-4 {
      flex-grow: 0;
      max-width: 33.333333%;
      flex-basis: 33.333333%;
    }

    .MuiGrid2-grid-xl-5 {
      flex-grow: 0;
      max-width: 41.666667%;
      flex-basis: 41.666667%;
    }

    .MuiGrid2-grid-xl-6 {
      flex-grow: 0;
      max-width: 50%;
      flex-basis: 50%;
    }

    .MuiGrid2-grid-xl-7 {
      flex-grow: 0;
      max-width: 58.333333%;
      flex-basis: 58.333333%;
    }

    .MuiGrid2-grid-xl-8 {
      flex-grow: 0;
      max-width: 66.666667%;
      flex-basis: 66.666667%;
    }

    .MuiGrid2-grid-xl-9 {
      flex-grow: 0;
      max-width: 75%;
      flex-basis: 75%;
    }

    .MuiGrid2-grid-xl-10 {
      flex-grow: 0;
      max-width: 83.333333%;
      flex-basis: 83.333333%;
    }

    .MuiGrid2-grid-xl-11 {
      flex-grow: 0;
      max-width: 91.666667%;
      flex-basis: 91.666667%;
    }

    .MuiGrid2-grid-xl-12 {
      flex-grow: 0;
      max-width: 100%;
      flex-basis: 100%;
    }
  }
`;
